import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { SolutionsPage } from './pages/SolutionsPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { AgentsPage } from './pages/AgentsPage';
import { PricingPage } from './pages/PricingPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { FreightSolutionPage } from './pages/solutions/FreightSolutionPage';
import { ShippingSolutionPage } from './pages/solutions/ShippingSolutionPage';
import { ConstructionSolutionPage } from './pages/solutions/ConstructionSolutionPage';
import { FinanceSolutionPage } from './pages/solutions/FinanceSolutionPage';
import { HealthcareSolutionPage } from './pages/solutions/HealthcareSolutionPage';
import { HospitalitySolutionPage } from './pages/solutions/HospitalitySolutionPage';
import { RealEstateSolutionPage } from './pages/solutions/RealEstateSolutionPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-9">
      <Routes data-id="element-10">
        <Route path="/" element={<App data-id="element-12" />} data-id="element-11" />
        <Route path="/solutions" element={<SolutionsPage data-id="element-14" />} data-id="element-13" />
        <Route path="/how-it-works" element={<HowItWorksPage data-id="element-16" />} data-id="element-15" />
        <Route path="/agents" element={<AgentsPage data-id="element-18" />} data-id="element-17" />
        <Route path="/pricing" element={<PricingPage data-id="element-20" />} data-id="element-19" />
        <Route path="/about" element={<AboutPage data-id="element-22" />} data-id="element-21" />
        <Route path="/contact" element={<ContactPage data-id="element-24" />} data-id="element-23" />
        <Route path="/solutions/freight" element={<FreightSolutionPage data-id="element-26" />} data-id="element-25" />
        <Route path="/solutions/shipping" element={<ShippingSolutionPage data-id="element-28" />} data-id="element-27" />
        <Route path="/solutions/construction" element={<ConstructionSolutionPage data-id="element-30" />} data-id="element-29" />
        <Route path="/solutions/finance" element={<FinanceSolutionPage data-id="element-32" />} data-id="element-31" />
        <Route path="/solutions/healthcare" element={<HealthcareSolutionPage data-id="element-34" />} data-id="element-33" />
        <Route path="/solutions/hospitality" element={<HospitalitySolutionPage data-id="element-36" />} data-id="element-35" />
        <Route path="/solutions/real-estate" element={<RealEstateSolutionPage data-id="element-38" />} data-id="element-37" />
      </Routes>
    </BrowserRouter>;
}